import styled from "styled-components";
import { Box } from "@mui/material";

const INK = "#14202b";
const BLUE_MID = "#4a7092";
const PEACH = "#fdad73";
const PEACH_DEEP = "#fd944d";
const EASE = "cubic-bezier(0.16, 1, 0.3, 1)";

export const HowItWorksWrapper = styled(Box)`
	padding: 88px 0 0;
	font-family: var(--poppins), "Poppins", sans-serif;
	color: ${INK};
	overflow-x: clip;

	h1,
	h2,
	h3,
	p {
		margin: 0;
	}

	.timeline {
		position: relative;
		margin-top: 56px;
		padding-left: 112px;
		max-width: 860px;
		margin-left: auto;
		margin-right: auto;
		display: flex;
		flex-direction: column;
		gap: 24px;
	}

	.track,
	.progress {
		position: absolute;
		left: 35px;
		top: 36px;
		bottom: 36px;
		width: 2px;
		border-radius: 2px;
	}
	.track {
		background: rgba(20, 32, 43, 0.12);
	}
	.progress {
		background: linear-gradient(180deg, ${PEACH}, ${PEACH_DEEP});
		transform-origin: top;
	}

	.step {
		position: relative;
		padding: 32px 36px;
		border-radius: 32px;
		background: #fff;
		box-shadow:
			inset 0 0 0 1px rgba(120, 157, 188, 0.22),
			0 24px 48px rgba(47, 75, 99, 0.07);
		transition:
			transform 0.45s ${EASE},
			box-shadow 0.45s ${EASE};

		&:hover {
			transform: translateY(-4px);
			box-shadow:
				inset 0 0 0 1px rgba(253, 148, 77, 0.4),
				0 30px 56px rgba(47, 75, 99, 0.12);
		}

		.badge {
			position: absolute;
			left: -112px;
			top: 0;
			display: grid;
			place-items: center;
			width: 72px;
			height: 72px;
			border-radius: 50%;
			color: ${INK};
			background: linear-gradient(135deg, #ffc49b, ${PEACH} 55%, ${PEACH_DEEP});
			box-shadow:
				0 0 0 8px #fff,
				0 14px 28px rgba(253, 148, 77, 0.35);
			svg {
				font-size: 30px;
			}
		}

		.step-label {
			font-size: 14px;
			font-weight: 600;
			letter-spacing: 0.02em;
			color: ${BLUE_MID};
		}
		.step-title {
			margin-top: 6px;
			font-family: inherit;
			font-size: clamp(22px, 2.4vw, 30px);
			font-weight: 700;
			letter-spacing: -0.025em;
			line-height: 1.2;
		}
		.step-description {
			margin-top: 12px;
			max-width: 56ch;
			font-size: 16px;
			line-height: 1.7;
			color: ${({ theme }) => theme.palette.text.secondary};
		}
	}

	${props => props.theme.breakpoints.down("md")} {
		padding-top: 80px;
		.timeline {
			margin-top: 56px;
			padding-left: 56px;
			gap: 16px;
		}
		.track,
		.progress {
			left: 19px;
			top: 20px;
			bottom: 20px;
		}
		.step {
			padding: 24px 22px;
			border-radius: 24px;
			.badge {
				left: -56px;
				width: 40px;
				height: 40px;
				box-shadow:
					0 0 0 5px #fff,
					0 8px 18px rgba(253, 148, 77, 0.35);
				svg {
					font-size: 20px;
				}
			}
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.step {
			transition: none;
			&:hover {
				transform: none;
			}
		}
	}
`;
